export interface ShopLink {
  id: string;
  label: string;
  href: string;
  hint: string;
}

export function getShopLinks(zelt: { name: string; marke: string }): ShopLink[] {
  const query = encodeURIComponent(`${zelt.marke} ${zelt.name} Zelt`);
  const amazonQuery = encodeURIComponent(`${zelt.marke} ${zelt.name}`);

  return [
    {
      id: "amazon",
      label: "Amazon",
      href: `https://www.amazon.de/s?k=${amazonQuery}`,
      hint: "Versand & Preise",
    },
    {
      id: "google",
      label: "Google Shopping",
      href: `https://www.google.com/search?tbm=shop&q=${query}`,
      hint: "Preisvergleich",
    },
    {
      id: "bergfreunde",
      label: "Bergfreunde",
      href: `https://www.bergfreunde.de/search/?searchparam=${query}`,
      hint: "Outdoor-Fachhändler",
    },
  ];
}
